(function($) {
    $(document).ready(function() {
        initIconsSwiper();
    })

    $(window).on('resize', function() {
        initIconsSwiper();
    })

    function initIconsSwiper() {
        var isMobile = $(window).width() < 750;

        $('.icons-carousel').each(function() {
            var $section = $(this);
            var $targets = $section.find('*').addBack();

            $targets.each(function() {
                var $el = $(this);
                var cached = $el.data('disableClassPairs');

                if (!cached) {
                    cached = ($el.attr('class') || '')
                        .split(/\s+/)
                        .filter(function(className) {
                            return className.indexOf('disable-') === 0;
                        })
                        .map(function(disabledClass) {
                            return {
                                disabled: disabledClass,
                                enabled: disabledClass.replace(/^disable-/, '')
                            };
                        })
                        .filter(function(pair) {
                            return pair.enabled.length > 0;
                        });
                    $el.data('disableClassPairs', cached);
                }

                if (!cached.length) return;

                if (isMobile) {
                    cached.forEach(function(pair) {
                        if ($el.hasClass(pair.disabled)) {
                            $el.removeClass(pair.disabled);
                            if (pair.enabled) $el.addClass(pair.enabled);
                        }
                    });
                } else {
                    cached.forEach(function(pair) {
                        if ($el.hasClass(pair.enabled)) {
                            $el.removeClass(pair.enabled);
                        }
                        $el.addClass(pair.disabled);
                    });
                }
            });

            $section.find('.icons-swiper').each(function() {
                var el = this;

                if (isMobile) {
                    if (el.swiper) return;

                    new Swiper(el, {
                        slidesPerView: 1,
                        spaceBetween: 50,
                        pagination: {
                            el: $(el).find('.swiper-pagination')[0],
                            clickable: true,
                        },
                    });
                } else if (el.swiper) {
                    el.swiper.destroy(true, true);
                }
            });
        });
    }
})(jQuery)